/**
 * rtc-errors.ts — shared, dependency-free RTC error types.
 *
 * Exists solely to break a circular import: rtc-call.ts imports
 * `negotiateOverWs`/`RtcWsNoAckError` from rtc-ws-negotiate.ts, and
 * rtc-ws-negotiate.ts used to import `RtcCallTimeoutError` back from
 * rtc-call.ts (for its own answer-timeout rejection) — a two-file cycle.
 * Both modules now import `RtcCallTimeoutError` from here instead; rtc-call.ts
 * still re-exports it (see its header) so existing importers (useCallMode.ts,
 * rtc-call.test.ts, rtc-ws-negotiate.test.ts) don't need to change their
 * import path. rtc-call.ts → rtc-ws-negotiate.ts stays a one-way dependency.
 */
export class RtcCallTimeoutError extends Error {
  /** `message` is a constructor param (not hardcoded) so a caller can supply
   *  transport-specific wording — e.g. rtc-ws-negotiate.ts's answer-timeout
   *  path uses a `[rtc-ws]`-prefixed message so logs never blame the REST
   *  `/api/rtc/call` endpoint for a WS-transport failure. Defaults to the
   *  ORIGINAL REST-path text so rtc-call.ts's own behavior/logs are
   *  unchanged by this move. */
  constructor(
    message = '[rtc-spike] /api/rtc/call timed out — no response within 15s'
  ) {
    super(message);
    this.name = 'RtcCallTimeoutError';
  }
}
